import { render, staticRenderFns } from "./StdButton.vue?vue&type=template&id=9fac0e42&scoped=true&"
import script from "./StdButton.vue?vue&type=script&lang=js&"
export * from "./StdButton.vue?vue&type=script&lang=js&"
import style0 from "./StdButton.vue?vue&type=style&index=0&id=9fac0e42&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fac0e42",
  null
  
)

export default component.exports